import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
var requireComponent = require.context('./fields', false, /\.js$/);
requireComponent.keys().forEach(function (filename) {
  var config = requireComponent(filename);
  var componentName = changeStr(filename.replace(/^\.\//, '').replace(/\.\w+$/, ''));
  Vue.component("My".concat(componentName), config.default || config);
});
function changeStr(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}